import React, { useEffect, useState, useMemo } from "react";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogContent from "@mui/joy/DialogContent";
import DataTable from "react-data-table-component";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import Carousel from "../components/Carousel.jsx";
import ImageIcon from "@mui/icons-material/Image";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { getCookie } from "../components/Cookie.jsx";
import { MultiSelect } from "react-multi-select-component";

const customStyles = {
  rows: {
    style: {
      minHeight: "3rem", // Override the row height
      fontSize: "0.875rem", // Set font size to small (14px)
      textAlign: "center",
    },
  },
  cells: {
    style: {
      wordWrap: "break-word",
      whiteSpace: "normal",
      fontSize: "0.7rem", // Set font size to small (14px)
      textAlign: "center", // Center-align the text in cells
      display: "flex",
      justifyContent: "center",
    },
  },
  headCells: {
    style: {
      backgroundColor: "#f1f4f9", // Set header background color to light gray
      color: "black", // Set header text color to black
      fontSize: "0.7rem", // Set font size to small (14px)
      textAlign: "center", // Center-align the text in header cells
      textAlign: "center", // Center-align the text in cells
      display: "flex",
      justifyContent: "center",
    },
  },
};

const Request_Modal = ({
  term,
  setLayout,
  layout,
  apiData,
  modalData,
  status,
  batchId,
}) => {
  const data = Array.isArray(modalData) ? modalData : [];
  const filteredData = data.filter((item) =>
    item.hasOwnProperty("screenshot_url")
  );

 
  

  const requestData =
    Array.isArray(apiData && apiData[0]?.comment) ||
    Array.isArray(apiData && apiData[0]?.file)
      ? apiData
      : [];
    
  //  console.log("daaaaaa",apiData);

  const parts = batchId.split("$");
  const secondIndex = parts[2];

  const [selectedImageUrl, setSelectedImageUrl] = useState("");
  const [selectedImageData, setSelectedImageData] = useState("");
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [open, setOpen] = React.useState(false);
  const [formData, setformData] = useState([]);
  const [minDate, setMinDate] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const token = getCookie("sqa_token");
  const [users, setUsers] = useState([]);
  const username = localStorage.getItem("email");


  // console.log("modal", modalData);

  useEffect(() => {
    if (apiData && apiData[0]?.assignedTo) {
      const preselectedOptions = apiData[0]?.assignedTo?.map((userEmail) => ({
        value: userEmail,
        label: userEmail,
      }));

      setSelectedUsers(preselectedOptions);
    }
  }, [apiData]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (isAgree) => {
    isAgree && confirmNotification();
    setOpen(false);
  };

  useEffect(() => {
    // Simulate API call
    getUsers();
  }, []);

  const getUsers = async () => {
    try {
      const url = `/sqa/api/get_all_users/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();

      if (data.result?.length > 0) {
        setUsers(data.result);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    // Get the current date
    const today = new Date();

    // Format the date to YYYY-MM-DD
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    // Set the minimum date
    setMinDate(formattedDate);
  }, []);

  const handleSlideChange = (index) => {
    setCurrentSlideIndex(index);
  };

  const handleDownloadImage = () => {
    const link = document.createElement("a");
    link.href = selectedImageUrl; // Ensure this contains the URL of the image you want to download
    link.download = "image.jpg"; // You can set a default file name
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const {
    register,
    handleSubmit,
    reset,
    setValue,

    formState: { errors },
  } = useForm();

  const confirmNotification = async function () {
    try {
      const response = await fetch("/sqa/api/create_request_notifications/", {
        method: "POST",
        body: formData,
        headers: {
          // Specify the content type for FormData
          Authorization: `Bearer ${token}`, // Replace with your actual token or authentication header
          // Add any other headers you need here
        }, // Send as FormData
      });

      if (!response.ok) {
        toast.error(`Message not sent for Request ID: ${modalData?._id}`);
        console.error("Network response was not ok");
      } else {
        const data = await response.json();

        if (data.result == 0) {
          return;
        }

        if (!data.result || data.result.length === 0) {
          toast.error(`Message not sent for Request ID: ${modalData?._id}`);
          return; // Exit the function early if there's no data
        }

        toast.success(`Message sent for Request ID ${modalData?._id}`);
      }
      // Handle success (e.g., show a success message, close the modal)
      setLayout(undefined);
    } catch (error) {
      // Handle error (e.g., show an error message)
    }
  };

  const onSubmit = async (data) => {
    try {
      const form = new FormData();
      form.append("title", data.title);
      form.append("assignedTo", data.assignedTo);
      form.append("description", data.description);
      form.append("comment", data.comment);
      form.append("createdBy", username);
      form.append("requestId", modalData?._id);
      form.append("type", "request");
      form.append("dueDate", data.dueDate);

      // Append the file if it exists
      if (data.file && data.file[0]) {
        form.append("file", data.file[0]);
      }
      setformData(form);
      handleClickOpen();
      // reset();
    } catch (error) {
      console.error("Error:", error);
      // Handle error (e.g., show an error message)
    }
  };

  const action_log = [
    { name: "Comment", selector: (row) => row.comment, sortable: true },
    { name: "By", selector: (row) => row.createdBy, sortable: true },
    { name: "Date-Time", selector: (row) => row.createdAt, sortable: true },
  ];

  const handleImageClick = (url,item) => {
    setSelectedImageUrl(url);
    setSelectedImageData(item)  
  };

  return (
    <React.Fragment>
      {term === "requestNotification" && (
        <Modal
          open={!!layout}
          onClose={() => {
            setLayout(undefined);
            setSelectedUsers([]);
            reset();
          }}
        >
          <ModalDialog
            layout={layout}
            sx={{
              margin: "auto",
              width: "80vw",
              height: "90vh", // Ensure it is responsive
            }}
          >
            <ModalClose />
            <DialogTitle> Add Notification Detail</DialogTitle>
            <DialogContent>
              <div className="container mx-auto p-4 text-xs">
                <div className="col-span-full">
                  <label className="block text-sm font-medium text-gray-700">
                    Title<span className="text-red-500">*</span>
                  </label>
                  <input
                    {...register("title", { required: "Title is required" })}
                    type="text"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  />
                  {errors.title && (
                    <span className="text-red-500">{errors.title.message}</span>
                  )}
                </div>

                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pb-5"
                >
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Request id
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5"
                      value={modalData?._id}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Client Id
                    </label>
                    <input
                      value={secondIndex || "-"}
                      disabled
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Created Date
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5"
                      value={modalData?.scrape_date}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Time Tag
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5"
                      value={modalData?.time_tag}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Due Date<span className="text-red-500">*</span>
                    </label>
                    <input
                      {...register("dueDate", {
                        required: "Due Date is required",
                        validate: (value) => {
                          const selectedDate = new Date(value);
                          const today = new Date();
                          return (
                            selectedDate >= today ||
                            "Due Date cannot be in the past"
                          );
                        },
                      })}
                      min={minDate}
                      type="date"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    />
                    {errors.dueDate && (
                      <span className="text-red-500">
                        {errors.dueDate.message}
                      </span>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Status
                    </label>
                    <input
                      type="text"
                      className="bg-gray-200 border border-gray-300 text-gray-500 text-sm rounded-lg block w-full p-2.5"
                      value={status}
                      disabled
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Assign To<span className="text-red-500">*</span>
                    </label>
                    {users && users[0] && (
                      <MultiSelect
                        options={users[0]?.map((user) => ({
                          value: user.email,
                          label: user.email,
                        }))}
                        value={selectedUsers} // Bind the component to the state
                        onChange={(selectedOptions) => {
                          setSelectedUsers(selectedOptions); // Update the state when the user selects an option
                          const selectedValues = selectedOptions.map(
                            (option) => option.value
                          );
                          setValue("assignedTo", selectedValues, {
                            shouldValidate: true,
                          });
                        }}
                        labelledBy="Select"
                        overrideStrings={{
                          selectSomeItems: "Select users...", // Custom placeholder text
                          allItemsAreSelected: "All Dashboards are selected",
                        }}
                      />
                    )}

                    {errors.assignedTo && (
                      <span className="text-red-500">
                        {errors.assignedTo.message}
                      </span>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700">
                      Add Visuals
                    </label>
                    <input
                      {...register("file")}
                      type="file"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                    />
                  </div>

                  <div className="col-span-full">
                    <label
                      htmlFor="description"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Description<span className="text-red-500">*</span>
                    </label>
                    <textarea
                      {...register("description", {
                        required: "Description is required",
                        minLength: {
                          value: 2,
                          message:
                            "Description must be at least 2 characters long",
                        },
                      })}
                      id="description"
                      rows="2"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Write your thoughts here..."
                    ></textarea>
                  </div>

                  <div className="col-span-full">
                    <div className="w-[100%]">
                      <h1 className="font-bold py-2">Comments</h1>
                      <DataTable
                        columns={action_log}
                        data={requestData[0]?.comment}
                        pagination
                        defaultSortFieldId={3}
                        defaultSortAsc={false}
                        pointerOnHover
                        customStyles={customStyles}
                        fixedHeader="true"
                        fixedHeaderScrollHeight="300px" // Apply custom styles here
                      />
                    </div>
                    <label
                      htmlFor="comment"
                      className="block mb-2 text-sm font-medium text-gray-900"
                    >
                      Add Comment
                    </label>
                    <textarea
                      {...register("comment")}
                      id="comment"
                      rows="2"
                      className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Add your Comment Here..."
                    ></textarea>
                  </div>

                  <div className="col-span-full text-center">
                    <button
                      type="submit"
                      className="bg-[#4880FF] px-4 py-2 rounded-md text-white hover:bg-blue-600"
                    >
                      Send Message
                    </button>
                  </div>
                </form>
              </div>
            </DialogContent>
          </ModalDialog>
        </Modal>
      )}

      {term === "requestScreenshot" && (
        <Modal open={!!layout} onClose={() => setLayout(undefined)}>
          <ModalDialog
            layout={layout}
            sx={{
              margin: "auto",
              width: "60vw",
              height: "95vh", // Ensure it is responsive
            }}
          >
            <ModalClose />
            <div className="text-lg w-full text-center border-b-2 py-2">
              {data[0]?._id}
            </div>
            <div className="flex flex-row justify-between text-sm">
              <div className="text-md ">
                <span className="font-semibold">Batch Id: </span>{" "}
                {data[0]?.batch_id}
              </div>

              <div className="text-sm">
                <div>
                  {" "}
                  <span className="font-semibold">
                    Batch Creation Time:{" "}
                  </span>{" "}
                  {data[0]?.time_tag}
                </div>

                <div>
                  {" "}
                  <span className="font-semibold">
                    {" "}
                    Batch Last Updated Time:
                  </span>
                  N/A
                </div>
              </div>
            </div>

            <DialogContent>
              <div className="w-full flex flex-row justify-between"></div>
              <div className="flex flex-row gap-10 justify-between h-[80vh]">
                <div className="w-[80%] h-full">
                  <Carousel
                    data={data}
                    selectedImageUrl={selectedImageUrl}
                    selectedImageData = {selectedImageData}
                    onSlideChange={handleSlideChange}
                    currentSlideIndex={currentSlideIndex}
                  />
                </div>
<div className="w-[20%] flex flex-col gap-5 h-full text-center text-[#4880FF] overflow-y-auto">
  {filteredData
    ?.filter(item => item.screenshot_url !== null) // Filter out items where screenshot_url is null
    .map((item, index) => (
      <div
        key={index}
        className="cursor-pointer flex flex-col items-center gap-2"
        onClick={() => handleImageClick(item.screenshot_url, item)}
      >
        <div className="hover:text-blue-600 border-2 rounded-full hover:border-blue-600">
          <ImageIcon fontSize="large" />
        </div>
        <div className="text-xs text-black">
          <p>{new Date(item.scrape_date).toLocaleDateString()}</p>
          <p>{item.time_tag}</p>
        </div>
      </div>
    ))}
</div>

              </div>
              <div className="pt-20 pr-48">
                <div className="w-full text-center text-sm">
                  <span className="font-semibold">
                    Date and Time Generation : {data[0]?.scrape_date} |{" "}
                    {data[0]?.time_tag}
                  </span>
                </div>
                {/* <div
                  onClick={handleDownloadImage}
                  className="w-full text-center"
                >
                  <button className="inline bg-[#4880FF] py-2 px-3 hover:bg-blue-600 text-white rounded-md">
                    Download Image
                  </button>
                </div> */}
              </div>
            </DialogContent>
          </ModalDialog>
        </Modal>
      )}

      {term === "reqData" && (
  <Modal open={!!layout} onClose={() => setLayout(undefined)}>
    <ModalDialog
      layout={layout}
      sx={{
        margin: "auto",
        width: "60vw",
        height: "95vh", // Keep height flexible
      }}
    >
      <ModalClose />
      <DialogContent sx={{marginTop:'0.5em'}}>
        {/* Container to style like a document */}
        <div className="w-full h-[80vh] flex justify-center items-center py-10 mt-6">
          {/* Scrollable MongoDB data section */}
          <div className="max-h-[80vh] w-full overflow-y-auto border shadow-lg rounded-lg bg-white p-6">
            <div className="prose max-w-none text-left">
              <h2 className="text-xl font-bold mb-4">MongoDB Document</h2>
              {/* Display MongoDB JSON data */}
              <pre className="whitespace-pre-wrap break-all text-sm bg-gray-100 p-4 rounded-lg border">
                {JSON.stringify(apiData, null, 2)}
              </pre>
            </div>
          </div>
        </div>
      </DialogContent>
    </ModalDialog>
  </Modal>
)}




      <Dialog
        open={open}
        onClose={() => handleClose(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="fixed inset-x-0 top-0 flex items-start justify-center p-4"
      >
        <div className="bg-white p-6 rounded-md shadow-lg">
          <div id="alert-dialog-title" className="text-lg">
            Notify
          </div>
          <div className="w-full border-b-2"></div>
          <DialogContent>
            <div id="alert-dialog-description" className="pt-6">
              Confirm if you want to send message for Request ID-
              {modalData?._id}
            </div>
          </DialogContent>
          <DialogActions>
            <button
              onClick={() => handleClose(true)}
              className="border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white rounded-md px-3 py-2"
            >
              Confirm
            </button>
            <button
              onClick={() => handleClose(false)}
              className="border border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white rounded-md px-3 py-2"
            >
              Cancel
            </button>
          </DialogActions>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

export default Request_Modal;
